import { render, staticRenderFns } from "./HeroFeatures.vue?vue&type=template&id=b8f2f67a&"
import script from "./HeroFeatures.vue?vue&type=script&lang=js&"
export * from "./HeroFeatures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports